// ------------------------------------------------------------------------------
// name: useDeviceDetect
// author: mudas
// created: 2025/6/16
// ------------------------------------------------------------------------------

import { useEffect, useState } from 'react';
import { useDeviceSelectors } from 'react-device-detect';
import { useDebounceFn } from 'ahooks';

export interface DeviceDetectsResult {
  isSmartTV: boolean;
  isConsole: boolean;
  isWearable: boolean;
  isEmbedded: boolean;
  isMobileSafari: boolean;
  isChromium: boolean;
  isMobile: boolean;
  isMobileOnly: boolean;
  isTablet: boolean;
  isBrowser: boolean;
  isDesktop: boolean;
  isAndroid: boolean;
  isWinPhone: boolean;
  isIOS: boolean;
  isChrome: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  isOpera: boolean;
  isIE: boolean;
  isEdge: boolean;
  isYandex: boolean;
  isIOS13: boolean;
  isIPad13: boolean;
  isIPhone13: boolean;
  isIPod13: boolean;
  isElectron: boolean;
  isEdgeChromium: boolean;
  isLegacyEdge: boolean;
  isWindows: boolean;
  isMacOs: boolean;
  isMIUI: boolean;
  isSamsungBrowser: boolean;

  osVersion: string; // '16.6';
  osName: string; // 'iOS';
  fullBrowserVersion: string; // '16.6';
  browserVersion: string; // '16';
  browserName: string; // 'Mobile Safari';
  mobileVendor: string; // 'Apple';
  mobileModel: string; // 'iPhone';
  engineName: string; // 'WebKit';
  engineVersion: string; // '605.1.15';
  getUA: string; // 'Mozilla/5.0 (iPhone; CPU iPhone OS 16_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6 Mobile/15E148 Safari/604.1';
  deviceType: string; // 'mobile';
}

export const useDeviceDetects = () => {
  const [userAgent, setUserAgent] = useState('');
  const [selectors] = useDeviceSelectors(userAgent);
  const [screen, setScreen] = useState<{ width: number; height: number }>({
    width: window.screen.width,
    height: window.screen.height,
  });

  const { run: resetAgent } = useDebounceFn(
    () => {
      setUserAgent(window.navigator.userAgent);
      setScreen({
        width: window.screen.width,
        height: window.screen.height,
      });
    },
    { wait: 16 },
  );

  useEffect(() => {
    window.addEventListener('load', resetAgent);
    // resetAgent();

    return () => {
      window.removeEventListener('load', resetAgent);
    };
  }, []);

  return { selectors: selectors as DeviceDetectsResult, screen };
};
